import {
	Component,
	OnInit,
	Input,
	EventEmitter,
	Output,
	OnChanges,
	ViewChild,
	ViewContainerRef,
	ElementRef,
} from "@angular/core";

@Component({
	selector: "app-screennavigatorwithtranscript",
	templateUrl: "./screennavigatorwithtranscript.directive.html",
	styleUrls: ["./screennavigatorwithtranscript.directive.css"],
})
export class ScreennavigatorwithtranscriptDirective
	implements OnInit, OnChanges
{
	@Input() transcriptText: string;
	@Input() showNextBtn?: Boolean;
	@Input() showPrevBtn?: Boolean;
	@Input() showTranscript: Boolean;
	@Input() textDirection: string;
	@Output() btnClickHandler?: EventEmitter<any> = new EventEmitter<any>();
	@ViewChild("midContainer", { static: true }) midContainer: ElementRef;

	constructor() {}

	ngOnInit() {}
	ngOnChanges(changes) {}

	ngAfterViewInit() {
		if (this.midContainer) {
			console.log(this.midContainer.nativeElement.scrollHeight);
		}
	}

	public previousBtnClickhandler() {
		this.btnClickHandler.emit({ button: "Previous" });
	}
	public nextBtnClickhandler() {
		this.btnClickHandler.emit({ button: "Next" });
	}

	public midContainerHeight(): string {
		if (
			getComputedStyle(
				this.midContainer.nativeElement.nextElementSibling,
				null
			).getPropertyValue("position") === `relative`
		) {
			return `0px`;
		} else {
			return this.midContainer.nativeElement.scrollHeight + 15 + "px";
		}
	}
}
